module.exports = __webpack_public_path__ + "img/P150T_weapon_57.b05253fd.png";